import { Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import { HrlenseInput } from '../../../../components/Input/Input';
import { IEditCandidateDetails, EditCandidateSchema, experince } from './modal';
import { Resolver, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Dropdown } from '../../../../components/DropDown/DropDown';
import { CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';

interface EditCandidateDetailsProps {
    selectedCandidate: any;
    isOpen: boolean;
    onClose: () => void;
    jobId: number;
    loadCandidateList: () => void;
}
export default function EditCandidateDetails({ selectedCandidate, isOpen, onClose, jobId, loadCandidateList }: EditCandidateDetailsProps) {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const [isExperienceCheck, setIsExperienceCheck] = useState<boolean>(false);
    const [genderOptions, setGenderOptions] = useState<{ gender: string; id: number }[]>([]);
    const { handleSubmit, control, formState: { errors }, reset, watch, } = useForm<IEditCandidateDetails>({
        resolver: yupResolver(EditCandidateSchema) as Resolver<IEditCandidateDetails>,
        defaultValues: selectedCandidate,
        mode: "onBlur",
    });

    useEffect(() => {
        reset({
            candidate_Name: selectedCandidate?.candidate_Name || "",
            gender: selectedCandidate?.gender || 0,
            email: selectedCandidate?.email || "",
            phone: selectedCandidate?.phone || "",
            current_Location: selectedCandidate?.current_Location || "",
            experience: selectedCandidate?.experience || false,
            experience_In_Months: selectedCandidate?.experience_In_Month || null,
            current_Salary: selectedCandidate?.current_Salary || null,
            expected_Salary: selectedCandidate?.expected_Salary || null,
        });
        setIsExperienceCheck(selectedCandidate?.experience || false);
    }, [selectedCandidate, reset]);

    const isExperienced = watch("experience");

    useEffect(() => {
        setIsExperienceCheck(isExperienced || false);
    }, [isExperienced]);


    const onSubmit = async (data: IEditCandidateDetails) => {
        let payload = {
            candidateMastId: selectedCandidate.candidate_Mast_Id,
            candidateName: data.candidate_Name,
            email: data.email,
            phone: data.phone,
            currentLocation: data.current_Location,
            experience: data.experience,
            experienceInMonths: data.experience_In_Months,
            currentSalary: data.current_Salary,
            expectedSalary: data.expected_Salary,
        }
        const response = await fetchApi("Candidate/updateCandidate", "PUT", payload);
        if (response) {
            loadCandidateList();
            addToast({ message: "Candidate details updated successfully", status: "success" });
            onClose();
        }
    }

    const loadGender = async () => {
        const response = await fetchApi("DropDown/Gender", "GET");
        if (response) {
            setGenderOptions(response);
        }
    }

    useEffect(() => {
        loadGender();
    }, [])

    return (
        <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Edit Candidate Details</DrawerHeader>
                <DrawerBody>
                    <HrlenseInput label='Candidate Name' name='candidate_Name' control={control} errors={errors} />
                    <Dropdown isRequired name="gender" label="Gender" control={control} errors={errors} placeholder="Select Gender" options={genderOptions} labelKey="gender" valueKey="id" />

                    <HrlenseInput label='Email' name='email' control={control} errors={errors} />
                    <HrlenseInput label='Phone' name='phone' control={control} errors={errors} />
                    <HrlenseInput label='Current Location' name='current_Location' control={control} errors={errors} />
                    <Dropdown isRequired name="experience" label="Experience" control={control} errors={errors} placeholder="Select Experience" options={experince} labelKey="label" valueKey="value" />

                    {isExperienceCheck && (
                        <>
                            <HrlenseInput label='Experience (in Months)' name='experience_In_Months' control={control} errors={errors} />
                            <HrlenseInput label='Current Salary' name='current_Salary' control={control} errors={errors} />
                            <HrlenseInput label='Expected Salary' name='expected_Salary' control={control} errors={errors} />
                        </>
                    )}
                </DrawerBody>
                <DrawerFooter>
                    <Button colorScheme='blue' mr={3} onClick={handleSubmit(onSubmit)}>
                        Update
                    </Button>

                </DrawerFooter>
            </DrawerContent>
        </Drawer>

    )
}
